export default "__VITE_ASSET__9FfjWvka__"